import { DrawerSectinProps } from "src/pages/reservaciones/inicio/Inicio.types"
import React, { useState } from "react"
import Avatar, { AvatarIconState, AvatarState } from "src/shared/components/data-display/avatar/avatar"
import Drawer from "src/shared/components/layout/drawer/Drawer"
import "./DrawerSectionPersonal.css"
import { Button } from "src/shared/components/forms"
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { toggleDrawer } from "src/store/navigation/navigationSlice"
import { RootState } from "src/store/store"
import DescriptionDetail from "src/shared/components/data-display/description-detail/DescriptionDetail"
import { ModalConfirm } from "src/shared/components/layout"
import Icon from "src/shared/icons"
import { useEliminarColaboradorMutation } from "src/gql/schema"
import useSnackbar from "src/shared/hooks/useSnackbar"
import DrawerWrappper from "../DrawerWrapper/DrawerWrappper"
import profileDefault from "src/assets/webp/profile_default.webp"
import { setColaboradores, togglePersonalDrawer } from "src/store/personal/personal.slice"
import getRolPrincipal from "../../pages/administracion-personal/helpers/getRolPrincipal"

const DrawerSectionPersonal = ({ visible = false, onClose = undefined, onDelete }: DrawerSectinProps) => {
    const { colaboradorSelected, colaboradores } = useSelector((state: RootState) => state.personal)
    const navigate = useNavigate()

    const [eliminarColaborador] = useEliminarColaboradorMutation()
    const { showSnackbar } = useSnackbar()
    const dispatch = useDispatch()
    function toggleDrawerState(value: boolean): void {
        dispatch(toggleDrawer(value))
    }

    const [isModalEliminarColaboradorOpen, setIsModalEliminarColaboradorOpen] = useState(false)

    return (
        <Drawer placement={"right"} bar={false} visible={visible} withCloseButton={true} onClose={onClose}>
            <>
                <DrawerWrappper className="drawerPersonal-wrapper">
                    <div className="drawerPersonal-title">
                        <Avatar
                            src={colaboradorSelected?.foto || profileDefault}
                            size={"xl"}
                            state={AvatarState.Loaded}
                            avatarIconState={AvatarIconState.online}
                        />
                        <div className="drawerPersonal-title__title">
                            {`${colaboradorSelected?.nombre || ""} ${colaboradorSelected?.apellido_paterno || ""} ${
                                colaboradorSelected?.apellido_materno || ""
                            }`}
                        </div>
                        <div className="drawerPersonal-title__subtitle">{`${
                            getRolPrincipal(colaboradorSelected?.colaborador_in_hotel).puestoNombre
                        } ${colaboradorSelected?.numero_colaborador || ""}`}</div>
                    </div>
                    <div className="drawerPersonal__container-info">
                        <DescriptionDetail
                            icon={"phone"}
                            label={"Telefono Personal"}
                            value={colaboradorSelected?.telefono_personal || ""}
                        />
                        <DescriptionDetail
                            icon={"mailFill"}
                            label={"Correo"}
                            style={{
                                padding: "12px 0",
                            }}
                            value={colaboradorSelected?.correo || ""}
                        />
                    </div>
                    <div className="drawerPersonal__divider"></div>
                    {!colaboradorSelected?.eliminado && (
                        <div className="drawerPersonal__buttons">
                            <Button
                                text="Editar perfil"
                                style={{ width: "90%" }}
                                theme="primary"
                                onClick={() => {
                                    onClose?.()
                                    if (sessionStorage.getItem("PINData")) {
                                        sessionStorage.removeItem("PINData")
                                    }
                                    toggleDrawerState(true)
                                    navigate("/u/addPerson", { state: { colaboradorSelected } })
                                }}
                            />
                            <Button
                                text="Eliminar de personal"
                                style={{ width: "90%" }}
                                className="button-border"
                                onClick={() => {
                                    setIsModalEliminarColaboradorOpen(true)
                                }}
                            />
                        </div>
                    )}
                </DrawerWrappper>
                <ModalConfirm
                    isOpen={isModalEliminarColaboradorOpen}
                    icon={<Icon name="ExclamationFilled" color="var(--pink-ocupado)" height={24} width={24} />}
                    iconTheme="danger"
                    title="Eliminar personal"
                    description={
                        <span style={{ color: "#667085" }}>
                            ¿Deseas eliminar a <strong style={{ fontWeight: 600 }}>{colaboradorSelected?.nombre} {colaboradorSelected?.apellido_paterno} {colaboradorSelected?.apellido_materno}</strong> del personal?
                            <span style={{ display: "block", marginTop: "10px", color: "#667085" }}>
                                A partir de ahora <strong style={{ fontWeight: 600 }}>no podrás asignar este colaborador a ningún turno o personal</strong> y <strong style={{ fontWeight: 600 }}>no tendrá acceso a Easyroom</strong>.
                            </span>
                        </span>
                    }
                    onCloseDialog={({ confirmed }) => {
                        setIsModalEliminarColaboradorOpen(false)
                        if (confirmed) {
                            eliminarColaborador({
                                variables: {
                                    colaborador: {
                                        colaborador_id: colaboradorSelected?.colaborador_id || "",
                                    },
                                },
                            })
                                .then(() => {
                                    dispatch(
                                        setColaboradores(
                                            colaboradores.filter(
                                                (c) => colaboradorSelected?.colaborador_id !== c.colaborador_id
                                            )
                                        )
                                    )
                                    dispatch(togglePersonalDrawer(false))
                                    showSnackbar({
                                        status: "success",
                                        title: "Perfil eliminado",
                                        text: `Eliminaste a **${colaboradorSelected?.nombre} ${colaboradorSelected?.apellido_paterno} ${colaboradorSelected?.apellido_materno}** de tu personal de ${colaboradorSelected?.colaborador_in_hotel?.[0]?.puesto?.nombre}s`,
                                    })
                                })
                                .catch(() => {
                                    dispatch(togglePersonalDrawer(false))
                                    showSnackbar({
                                        title: "Error al crear eliminar colaborador",
                                        status: "error",
                                        text: "¡Ups! Se ha producido un error. Por favor, inténtalo nuevamente",
                                    })
                                })
                                .finally(() => {
                                    toggleDrawerState(false)
                                })
                        }
                    }}
                />

            </>
        </Drawer>
    )
}

export default DrawerSectionPersonal
